import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const AcessingPerson = ({
  personName,
  personFunction,
  personSeniorLevel,
  personAdmissionDate,
}) => (
  <S.Container>
    <S.Small>Você está avaliando</S.Small>
    <S.PersonName>{personName}</S.PersonName>
    <S.PersonInfos>
      <span>Função:</span>
      <p>{personFunction}</p>
    </S.PersonInfos>
    <S.PersonInfos>
      <span>Senioridade:</span>
      <p>{personSeniorLevel}</p>
    </S.PersonInfos>
    <S.PersonInfos>
      <span>Admissão:</span>
      <p>{personAdmissionDate}</p>
    </S.PersonInfos>
  </S.Container>
);

export default AcessingPerson;

AcessingPerson.defaultProps = {
  personAdmissionDate: new Date(),
};

AcessingPerson.propTypes = {
  personName: PropTypes.string.isRequired,
  personFunction: PropTypes.string.isRequired,
  personSeniorLevel: PropTypes.string.isRequired,
  personAdmissionDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
};
